import { Trans } from '@lingui/macro';
import { useNumberFormat } from 'hooks/useNumberFormat';
import styles from './NoAvailableFundsSubheading.module.css';

type TProps = {
  requestedAmount?: number;
};

export const NoAvailableFundsSubheading = ({ requestedAmount }: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <>
      <p className={styles.noAvailableFundsSubheading}>
        <Trans>
          Whilst our credit assessment of your client is positive, the offer
          amount of {formatCurrency(requestedAmount)} is less than their current
          balance.
        </Trans>
      </p>
      <p className={styles.noAvailableFundsSubheading}>
        <Trans>
          Unfortunately this means there are no available funds to draw down at
          this time.
        </Trans>
      </p>
    </>
  );
};
